export default {
  setTexts: (state, payload) => { state.texts = payload },
  setSliders: (state, payload) => { state.sliders = payload },
  setBanner: (state, payload) => { state.banner = payload }
}